<template>
  <div>
    <div class="qualification_box">
      <div class="qualification">
        <div class="qualification_swiper">
          <el-carousel :autoplay="true">
            <el-carousel-item
              v-for="(item, index) in qualificationAndHonorsList"
              :key="index"
            >
              <el-image
                style="width: 570px; height: 260px"
                :src="item.image_url"
                fit="cover"
              ></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="qualification_content">
          <vue-seamless
            :data="qualificationAndHonorsList"
            class="seamless-warp"
            :class-option="defaultOption"
          >
            <div
              class="qualification_name one-write"
              v-for="(item, index) in qualificationAndHonorsList"
              :key="index"
            >
              <img src="@/assets/images/index/qualifi.png" />
              {{ item.content }}
            </div>
          </vue-seamless>
        </div>
      </div>
    </div>
    <button class="common-more-button" @click="goHonors()">查看更多</button>
  </div>
</template>
<script>
import vueSeamless from "vue-seamless-scroll";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    vueSeamless,
  },
  data() {
    return {
    };
  },
  mounted() {
    this.getQualificationData();
  },
  methods: {
    ...mapActions(["getQualificationAndHonorsList"]),
    getQualificationData() {
      let data = {
        per_page: 5,
        page: 1,
      };
      this.getQualificationAndHonorsList(data);
    },
    // 查看更多
    goHonors() {
      this.$router.push({ path: "/qualification-and-honors" });
    },
  },
  computed: {
    ...mapGetters(["qualificationAndHonorsList"]),
    defaultOption() {
      return {
        step: 1, //步长 越大滚动速度越快
        limitMoveNum: 5, //启动无缝滚动最小数据量 this.dataList.length
        hoverStop: true, //是否启用鼠标hover控制
        direction: 1, //1 往上 0 往下
        openWatch: true, //开启data实时监听
        singleHeight: 50, //单条数据高度有值hoverStop关闭
        waitTime: 1500, //单步停止等待时间
      };
    },
  },
};
</script>
<style scoped>
/* 资质荣誉 */
.qualification_box {
  width: 1240px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 70px auto 50px;
}
.qualification_box >>> .el-carousel__container {
  width: 100%;
  height: 264px;
}
.qualification {
  width: 1240px;
  height: 264px;
  display: flex;
}
.qualification_swiper {
  width: 570px;
  height: 260px;
  border-radius: 20px;
  overflow: hidden;
}
.qualification_swiper img {
  max-width: 100%;
  max-height: 100%;
}
.qualification_content {
  width: 610px;
  height: 260px;
  font-size: 18px;
  margin-left: 60px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}
/* 文字轮播 */
.qualification_name {
  width: 610px;
  height: 50px;
  line-height: 50px;
}

.qualification_name img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/CommonQualification.vue